// ======================================================================
// File Name       : ContentUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import moment from 'moment';
import { ANSWER_FORMULA_NUM, MULTI_LANGUAGE_STATUS_NAME, PROCESS_RESULT_STATUS_NAME, PROCESS_STATUS_NAME, QUESTION_SELECT_METHOD, QUESTION_SELECT_METHOD_LIST } from '../constants/ContentConstant';
import { SELECT_BOX_DATA } from '../constants/SelectBoxData';
import { htmlEntities } from '../utils/index';
/**
 * Get String Start Condition
 * @param dataList (the name of selectbox)
 * @param val (value of item in selectbox)
 * @return String Start Condition
 */
export function getStartCondition(dataList, val) {
  if (!val) {
    return '';
  }
  const startConditions = val;
  let startConditionStr = '';
  dataList.forEach(function (item) {
    startConditions.forEach(function (conditionItem) {
      if (parseInt(item.value, 10) === parseInt(conditionItem, 10)) {
        startConditionStr += item.name;
        startConditionStr += '\n';
      }
    }, this);
  }, this);
  return startConditionStr;
}

/**
 * Get question list
 * @param drillGroupArray
 * @return array list question
 */
export function getQuestionList(drillGroupArray) {
  if (!drillGroupArray) {
    return '';
  }
  const questionList = [];
  drillGroupArray.forEach(function (item) {
    let questionScope = item.drillQuestionIdScope;
    if (questionScope.indexOf('0_') >= 0) {
      questionScope = questionScope.replace('0_', '');
      const questionScopeList = questionScope.split('/');
      questionScopeList.forEach(function (question) {
        questionList.push(question);
      }, this);
    }
  }, this);
  return questionList;
}

/**
 * Get question list array
 * @param drillGroupArray
 * @return array list question
 */
export function getQuestionListArr(drillGroupArray) {
  if (!drillGroupArray) {
    return '';
  }

  const questionListArray = [];
  drillGroupArray.forEach((item) => {
    const drillGroupId = item.drillGroupId;
    let questionScope = item.drillQuestionIdScope;
    const groupPoint = item.groupPoint;
    // STEP10.0.0 START
    const questionSelectMethod = item.questionSelectMethod;
    let questionCount = null;
    if (questionSelectMethod === QUESTION_SELECT_METHOD.RANDOM) {
      questionCount = item.questionCount;
    }
    // STEP10.0.0 END
    if (questionScope && questionScope.indexOf('0_') >= 0) {
      const questionListTmp = [];
      questionScope = questionScope.replace('0_', '');
      const questionScopeList = questionScope.split('/');
      questionScopeList.forEach((question) => {
        questionListTmp.push(question);
      }, this);

      questionListArray.push({ drillGroupId, questionListTmp, groupPoint, questionSelectMethod, questionCount }); // STEP10.0.0
    }
  }, this);
  return questionListArray;
}

/**
 * Function check status Drill End Condition or not
 * @param drillHistoryInfo
 * @param itemInfo
 * @return true/false
 */
export function isDrillEndCondition(drillHistoryInfo, itemInfo) {
  if (!drillHistoryInfo || !itemInfo) {
    return true;
  }
  let {
    drillResultNum,
    perfectPoint,
    drillResultExp,
    questionCount,
  } = drillHistoryInfo;
  let { progressRatioForItemEnd } = itemInfo;
  const { endConditionTypeForItem } = itemInfo;
  drillResultNum = drillResultNum ? parseInt(drillResultNum, 10) : 0;
  perfectPoint = perfectPoint ? parseInt(perfectPoint, 10) : 0;
  drillResultExp = drillResultExp ? parseInt(drillResultExp, 10) : 0;
  questionCount = questionCount ? parseInt(questionCount, 10) : 0;
  progressRatioForItemEnd = progressRatioForItemEnd ? parseInt(progressRatioForItemEnd, 10) : 0;
  drillResultExp = parseInt(drillResultExp, 10);
  if (endConditionTypeForItem) {
    let result = 100;
    if (drillResultExp === 0) {
      if (questionCount === 0) {
        result = 100;
      } else {
        result = (drillResultNum / questionCount) * 100;
        result = parseInt(result, 10);
      }
    } else if (drillResultExp === 1) {
      result = drillResultNum;
    } else if (drillResultExp === 2) {
      if (perfectPoint === 0) {
        result = 100;
      } else {
        result = (drillResultNum / perfectPoint) * 100;
        result = parseInt(result, 10);
      }
    }
    if (result < progressRatioForItemEnd) {
      return false;
    }
  }
  return true;
}

/**
 * Function create Drill Percent Learning
 * @param drillHistoryInfo
 * @return string displayText
 */
export function getDrillPercentLearning(drillHistoryInfo) {
  let displayText = '-';
  if (!drillHistoryInfo) {
    return displayText;
  }
  let {
    drillResultNum,
    perfectPoint,
    drillResultExp,
    questionCount,
  } = drillHistoryInfo;
  drillResultNum = drillResultNum ? parseInt(drillResultNum, 10) : 0;
  perfectPoint = perfectPoint ? parseInt(perfectPoint, 10) : 0;
  drillResultExp = drillResultExp ? parseInt(drillResultExp, 10) : 0;
  questionCount = questionCount ? parseInt(questionCount, 10) : 0;
  drillResultExp = parseInt(drillResultExp, 10);
  let percentLearning = 0;
  if (drillResultExp === 0) {
    if (questionCount === 0) {
      percentLearning = 100;
    } else {
      percentLearning = (drillResultNum / questionCount) * 100;
      percentLearning = parseInt(percentLearning, 10);
    }
    displayText = `${parseInt(percentLearning, 10)}%`;
  } else if (drillResultExp === 1) {
    displayText = `${parseInt(drillResultNum, 10)}%`;
  } else if (drillResultExp === 2) {
    if (perfectPoint === 0) {
      percentLearning = 100;
    } else {
      percentLearning = (drillResultNum / perfectPoint) * 100;
      percentLearning = parseInt(percentLearning, 10);
    }
    displayText = `${parseInt(percentLearning, 10)}%`;
  } else if (drillResultExp === 3) {
    displayText = '中断';
  }
  return displayText;
}

export function checkDateLimit(dateFrom, dateTo, dateFromCompare, dateToCompare) {
  let shouldAdd = true;
  if (dateFrom && dateFromCompare) {
    dateFrom = moment(dateFrom).startOf('day');
    dateFromCompare = moment(dateFromCompare).startOf('day');
    shouldAdd = dateFrom.isSameOrBefore(dateFromCompare);
  }
  if (!shouldAdd) {
    return false;
  }
  if (dateTo && dateToCompare) {
    dateTo = moment(dateTo).startOf('day');
    dateToCompare = moment(dateToCompare).startOf('day');
    shouldAdd = dateTo.isSameOrAfter(dateToCompare);
  }
  return shouldAdd;
}

export function convertContentHistoryObjectToList(
  dataList,
  namePrimaryKey,
  nameMapArray) {
  if (dataList && dataList.length !== 0) {
    const bySecernId = dataList.reduce((newData, obj) => {
      if (Object.prototype.hasOwnProperty.call(newData, obj[namePrimaryKey])) {
        newData[obj[namePrimaryKey]].count += 1;
      } else {
        newData[obj[namePrimaryKey]] = {
          count: 1,
        };
      }
      return newData;
    }, {});
    return bySecernId;
  }
  return [];
}

export function setDataSingleQuestion(answerFormula, optionArray, correctAnswer, correctNumber) {
  let answerInfo = [];
  answerFormula = parseInt(answerFormula, 10);
  switch (answerFormula) {
    case ANSWER_FORMULA_NUM.SELECTIVE_SINGLE_ANSWER:
    case ANSWER_FORMULA_NUM.SELECTIVE_MULTIPLE_ANSWER:
      if (optionArray && optionArray.length) {
        answerInfo = parseSelectiveAnswer(optionArray, correctNumber, false);
      }
      break;
    case ANSWER_FORMULA_NUM.SELECTIVE_SORT_ANSWER:
      if (optionArray && optionArray.length) {
        answerInfo = parseSelectiveAnswer(optionArray, correctNumber, true);
      }
      break;
    case ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER:
    case ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER:
      if (correctAnswer) {
        answerInfo = parseDecriptiveAnswer(
          correctAnswer,
          false,
          false,
          '/',
        );
      }
      break;
    case ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT:
    case ANSWER_FORMULA_NUM.DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER:
      if (correctAnswer) {
        answerInfo = parseDecriptiveAnswer(
          correctAnswer,
          true,
          false,
          '__',
        );
      }
      break;
    case ANSWER_FORMULA_NUM.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER:
      if (correctAnswer) {
        answerInfo = parseDecriptiveAnswer(
          correctAnswer,
          true,
          true,
          '__',
        );
      }
      break;
    default:
      break;
  }
  return answerInfo;
}

export function parseSelectiveAnswer(optionArray, correctNumber, isSort) {
  const answerInfo = [];
  let answerJson = {};
  try {
    const length = optionArray.length;
    const correctNumberArr = correctNumber ? correctNumber.split('_') : [];
    for (let i = 0; i < length; i++) {
      answerJson = {
        index: optionArray[i].optionNumber,
        answerChoice: htmlEntities(optionArray[i].optionContent),
        subAnswer: [],
      };
      if (isSort) {
        const test = correctNumberArr.indexOf((i + 1).toString());
        answerJson.correctAnswerNumber = test > -1 ? (test + 1) : '';
      } else {
        const test = correctNumberArr.indexOf((i + 1).toString()) > -1;
        if (test) {
          answerJson.isCorrectAnswer = true;
        }
      }
      answerInfo.push(answerJson);
    }
  } catch (error) {
    console.log(error);
  }
  return answerInfo;
}

export function parseDecriptiveAnswer(correctAnswer, isMultiple, isSort, splitKey) {
  const answerInfo = [];
  let answerJson = {};
  try {
    const correctAnswerArr = correctAnswer ? correctAnswer.split(splitKey) : [];
    if (isMultiple) {
      for (let i = 0; i < correctAnswerArr.length; i++) {
        const subCorrectAnswerArr = correctAnswerArr[i].split('/');
        const answerChoice = subCorrectAnswerArr[0];
        subCorrectAnswerArr.shift();
        answerJson = {
          index: 0,
          correctAnswer: answerChoice,
          subAnswer: subCorrectAnswerArr,
        };
        if (isSort) {
          answerJson.correctAnswerNumber = i + 1;
        }
        answerInfo.push(answerJson);
      }
    } else {
      const answerChoice = correctAnswerArr[0];
      correctAnswerArr.shift();
      answerJson = {
        index: 0,
        correctAnswer: answerChoice,
        subAnswer: correctAnswerArr,
      };
      answerInfo.push(answerJson);
    }
  } catch (error) {
    console.log(error);
  }
  return answerInfo;
}

export function toggle(e) {
  const { id } = e.target;
  if ($(`#${id}`).attr('aria-expanded') === 'true') {
    $(`#${id}`).removeClass('plus').addClass('minute');
  } else {
    $(`#${id}`).removeClass('minute').addClass('plus');
  }
}

export function convertLanguageShortName(languageCode) {
  const index = SELECT_BOX_DATA.TRANSLATION_LANGUAGE_SHORT_NAME.findIndex(obj => obj.value === languageCode);
  if (index < 0) {
    return '';
  }
  return SELECT_BOX_DATA.TRANSLATION_LANGUAGE_SHORT_NAME[index].name || '';
}

export function convertLanguageName(languageCode) {
  const index = SELECT_BOX_DATA.TRANSLATION_LANGUAGE.findIndex(obj => obj.value === languageCode);
  if (index < 0) {
    return '';
  }
  return SELECT_BOX_DATA.TRANSLATION_LANGUAGE[index].name || '';
}

export function changeMultiLanguageStatus(type) {
  try {
    const typeInt = parseInt(type, 10);
    return MULTI_LANGUAGE_STATUS_NAME[typeInt].name;
  } catch (error) {
    return type;
  }
}

export function changeMultiLanguageProcessStatus(processStatusCode) {
  try {
    const statusValue = parseInt(processStatusCode, 10);
    return PROCESS_STATUS_NAME[statusValue].name;
  } catch (error) {
    return processStatusCode;
  }
}

export function changeMultiLanguageProcessResultStatus(processResultStatusCode) {
  try {
    const statusValue = parseInt(processResultStatusCode, 10);
    return PROCESS_RESULT_STATUS_NAME[statusValue].name;
  } catch (error) {
    return processResultStatusCode;
  }
}

export function getFileExtension(fileName) {
  if (!fileName) return '';
  return fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
}

// #7245 START
export function calculateTotalAbsolutePoint(subQuestionArray) {
  return subQuestionArray.reduce((total, currentValue) => {
    if (currentValue.subAbsolutePoint) {
      total += currentValue.subAbsolutePoint;
    }
    return total;
  }, null);
}
// #7245 END

// #7434 START
/**
 * Return rounded value and support max value
 * Ex:
 * 514 -> 550
 * 32767 -> 35000
 * @param value (integer)
 * @param isGetMax (boolean)
 * @returns rounded value
 */
export function calculateHistogramYAxisMaxValue(value, isGetMax) {
  const numCount = String(value).length;
  let result = 0;
  if (numCount === 1) {
    result = isGetMax ? 10 : value;
  } else if (numCount === 2) {
    if (value <= 50) {
      value = isGetMax ? 50 : value;
    } else {
      value = isGetMax ? 100 : value;
    }
    result = value;
  } else {
    const basePower = 10 ** (numCount - 1);
    const ratio = value / basePower;
    result = ((Math.ceil(ratio * 2)) / 2) * basePower;
  }
  return result;
}
// #7434 END

// STEP10.0.0 START
export function getQuestionMethodName(type) {
  try {
    const typeInt = parseInt(type, 10);
    return QUESTION_SELECT_METHOD_LIST[typeInt].name;
  } catch (error) {
    return type;
  }
}
// STEP10.0.0 END
